import Flickity from "flickity";
import { CountUp } from 'countup.js';

export default class LogoTicker {
  constructor() {
    const $els = document.querySelectorAll('.js-logo-ticker-carousel');
    $els.forEach($el => new Carousel($el));

    const $countups = document.querySelectorAll('.js-countup');
    $countups.forEach($el => {
      var countUp = new CountUp($el, $el.dataset.count, {
        enableScrollSpy: true,
        suffix: '+',
        onCompleteCallback: () => $el.classList.add('c-countup-complete')
      });
      countUp.start();
    });
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;

    this.$el.classList.remove('flex')

    this.carousel = new Flickity(this.$el, {
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      imagesLoaded: true,
      draggable: false
    });

    // Set initial position to be 0
    this.carousel.x = 0;

    // Start the marquee animation
    this.play();
  }

  play() {
    this.carousel.x = this.carousel.x - 1.05;
    this.carousel.settle(this.carousel.x);
    this.requestId = window.requestAnimationFrame(this.play.bind(this));
  }
}
